class Tab {
  constructor() {
    this.tabAll = document.querySelector("#all");
    this.tab = document.querySelectorAll('input[name="tab"]');
    this.tagList = document.querySelector(".p-service-header__tag-list");
    this.currentValue = "";

    this.initialize();
    this.update();
  }

  initialize() {
    if (!this.tabAll) return;
    this.tabAll.checked = true;
    this.currentValue = this.tabAll.value;
    this.tagList.hidden = false;
  }

  update() {
    this.tab.forEach((r) =>
      r.addEventListener("change", (e) => {
        this.currentValue = e.target.value;

        if (this.currentValue !== "value1") {
          this.tagList.hidden = true;
        } else {
          this.tagList.hidden = false;
        }
      })
    );
  }
}

export { Tab };
